var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-modal',{ref:"company-edit-modal",attrs:{"size":"lg"}},[_c('p',{staticStyle:{"font-size":"34px","color":"red","font-weight":"bold"}},[_vm._v("EJ KLAR - EJ KLAR - EJ KLAR")]),_c('BasicCompanySettings',{attrs:{"company":_vm.company,"regions":_vm.regions,"extras":_vm.extras}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }